import axios from "axios";
import { TOKEN_KEY } from "../Components/common";
import { message, notification } from "~node_modules/antd/es";
import { endpoints } from './endpoints';

// Add this import for API_BASE_URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const axiosInstant = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL as string,

});

// @ts-ignore
axiosInstant.interceptors.request.use((axiosConfig) => {
  const token = localStorage.getItem('ACCESS_TOKEN');
  if (token) {
    // Token may already include 'Bearer ' prefix from OAuth
    axiosConfig.headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }
  return axiosConfig;
});

const logoutUser = () => {
  // Keep the page the user was trying to reach across the wipe. A session that
  // expires while opening an email link would otherwise lose the destination
  // here and land on the marketing page with nothing to click.
  const pendingRedirect = localStorage.getItem("postLoginRedirect");
  localStorage.clear();
  if (pendingRedirect) localStorage.setItem("postLoginRedirect", pendingRedirect);
  // /signin, not "/": an expired session wants the Google and Microsoft buttons.
  window.location.pathname = "/signin";
};

axiosInstant.interceptors.response.use(
  (response) => {
    if (response.status === 401) logoutUser();
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) logoutUser();
    return Promise.reject(error);
  }
);

export const saveCandidateProfile = async (formData: FormData) => {
  const response = await axiosInstant.post(endpoints.candidateProfile, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getCandidateProfile = async (candidateId: string) => {
  const response = await axiosInstant.get(`${endpoints.candidateProfile}/${candidateId}`);
  return response.data;
};

export const getInvitationsForCandidate = async (candidateId: string) => {
  const response = await axiosInstant.get(`/invites?candidateId=${candidateId}`);
  return response.data;
};

export const acceptInvitation = async (token: string, candidateId: string) => {
  const response = await axiosInstant.post(endpoints.acceptInvite(token), {
    candidateId,
  });
  return response.data;
};

export const declineInvitation = async (token: string, candidateId: string) => {
  const response = await axiosInstant.post(endpoints.declineInvite(token), { candidateId });
  return response.data;
};

export const fetchRecruiterJobs = async () => {
  const response = await axiosInstant.get(endpoints.fetchRecruiterJobs);
  return response.data;
};

export const createJob = async (jobData: any) => {
  const response = await axiosInstant.post(endpoints.createJob, jobData);
  return response.data;
};

export const getJobById = async (jobId: string) => {
  const response = await axiosInstant.get(endpoints.getJobById(jobId));
  return response.data;
};

export const getJobs = async () => {
  const response = await axiosInstant.get(endpoints.getJobs);
  return response.data;
};

export const handleSendInvite = async (selectedJob: any, values: any) => {
  const response = await axiosInstant.post(endpoints.handleSendInvite, {
    jobId: selectedJob?._id,
    candidateName: values.candidateName,
    candidateEmail: values.candidateEmail,
  });
  return response.data;
};

export const fetchCandidatePool = (recruiterId: string) =>
  axiosInstant.get(endpoints.candidatePool(recruiterId));

export const fetchMyJobApplications = () =>
  axiosInstant.get(endpoints.myJobApplications);

export const fetchRemarksForJobApplication = async (jobApplicationId: string) => {
  const response = await axiosInstant.get(endpoints.getRemarksForJobApplication(jobApplicationId));
  return response.data;
};

export const saveProfile = async (payload: any) => {
  const response = await axiosInstant.post(endpoints.saveProfile, payload);
  return response.data;
};

export const getProfileByUserId = async (userId: string) => {
  console.log("API: getProfileByUserId", userId);
  const response = await axiosInstant.get(endpoints.getProfileByUserId(userId));
  console.log("API response:", response.data);
  return response.data;
};

export const saveProfileWithInviteToken = async (formData: FormData, inviteToken: string) => {
  const response = await axios.post(
    `${API_BASE_URL}${endpoints.getProfileByInviteToken(inviteToken)}`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
  return response.data;
};

export const getProfileByInviteToken = async (inviteToken: string) => {
  const response = await axios.get(
    `${API_BASE_URL}${endpoints.getProfileByInviteToken(inviteToken)}`
  );
  return response.data;
};  

// Uploads a profile photo and returns the URL/path from the backend



export async function savePreScreeningAnswers(applicationId: string, answers: any) {
  return axiosInstant.patch(`/job-applications/${applicationId}/pre-screening-answers`, { answers })
    .then(res => res.data);
}

export const updateMyCandidateCalendar = async (calendarInput: any) => {
  const response = await axiosInstant.post(endpoints.myCandidateCalendar, calendarInput);
  return response.data;
};

export const getCandidateCalendar = async (candidateId: string, month: number) => {
  const response = await axiosInstant.get(endpoints.getCandidateCalendar(candidateId, month));
  return response.data;
};

export const getManagerJobs = async () => {
  const response = await axiosInstant.get(endpoints.jobs.manager.myJobs);
  return response.data;
};

export const getNotifications = () =>
  axiosInstant.get('/notifications/my').then(res => res.data);

export const markNotificationAsRead = (id: string) =>
  axiosInstant.patch(`/notifications/${id}/read`).then(res => res.data);

export const getNotificationSettings = () =>
  axiosInstant.get('/notifications/settings/my').then(res => res.data);

export const updateNotificationSettings = (settings: any) =>
  axiosInstant.patch('/notifications/settings/my', settings).then(res => res.data);

export async function markInvitesAsRead(jobId: string) {
  return axios.post(`/invites/mark-read/${jobId}`);
} 